import { Link } from "react-router-dom";
import '../../utils/Css/Style.css';
import React from 'react';
const EmployeeDashboard = () => {

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container">
          <div className="row mb-2">
            <div className="col-sm-6">
              {/* <h1 className="m-0">Tableau de bord de l'employé</h1> */}
            </div>
            <div className="col-sm-6">
              {/* <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item"><Link to="/Employee" style={{ color: "black" }}>Home</Link></li>
                <li className="breadcrumb-item active" style={{ color: "black" }}>Tableau de bord</li>
              </ol> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployeeDashboard;